export default __webpack_public_path__ + "media/zurb/img/events/wired/second-harvest/second-harvest-thumb-626382db2c24b31c11b9d1bd358d6140.png";